import {processenv} from "processenv";

export const apiTendersUrl = `${processenv("API_URL")}/tenders`;
